import clsx from 'clsx';
import styles from './styles.module.scss';

export interface IRadioButtonProps {
  name?: string;
  label?: string;
  checked?: boolean;
  disabled?: boolean;
  onChange?(event: React.ChangeEvent<HTMLInputElement>): void;
  className?: string;
}

export const RadioButton = (props: IRadioButtonProps) => {
  const { disabled, name, checked, onChange, label, className } = props;

  return (
    <label className={clsx(styles.checkBoxContainer, className)}>
      <div className={styles.check}>
        <input
          type='radio'
          name={name}
          checked={checked}
          disabled={disabled}
          onChange={onChange}
          className={styles.checkInput}
        />
        <div className={styles.checkBox} />
      </div>

      <span className={styles.label}>{label}</span>
    </label>
  );
};
